import React from "react";
import _ from "lodash";
import { SearchOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserPlus,
  faCloudUploadAlt,
  faCloudDownloadAlt,
  faSearchMinus
} from "@fortawesome/free-solid-svg-icons";
import { withRouter } from "react-router-dom";
import { Button, Select, Form, Input, Row, Col, Tooltip } from "antd";

const { Option } = Select;

class FormOne extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hmgId: null,
      hotelId: null,
    };
  }

  formOneOnFinish = (e) => {
    this.props.formOneOnFinish(e);
  };

  hmgIdOnChange = (v) => {
    const { formRef, dataOne } = this.props;
    const hotelOptions = dataOne
      .filter((item) => {
        if (v) {
          if (item.hmg_id === v) {
            return true;
          }
          return false;
        }
        return true;
      })
      .sort((a, b) => a.hotel_name.localeCompare(b.hotel_name));
    if (
      hotelOptions &&
      hotelOptions.length === 1 &&
      hotelOptions[0] &&
      hotelOptions[0].hotel_id
    ) {
      formRef.current.setFieldsValue({ hotel_id: hotelOptions[0].hotel_id });
    } else {
      formRef.current.setFieldsValue({ hotel_id: "All" });
    }
    this.setState({ hmgId: v });
  };

  render() {
    const { formRef, dataOne, dataTwo, history, exportOnClick } = this.props;

    const formOneValues = formRef?.current?.getFieldValue() ?? null;

    const allHmgOptions = _.uniqBy(dataOne, "hmg_name")
      .sort((a, b) => a.hmg_name.localeCompare(b.hmg_name))
      .map((d) => (
        <Option key={d.hmg_name} value={d.hmg_id}>
          {d.hmg_name}
        </Option>
      ));

    const hotelOptions = dataOne
      .filter((item) => {
        if (formOneValues && formOneValues.hmg_id) {
          if (item.hmg_id === formOneValues.hmg_id) {
            return true;
          }
          return false;
        }
        return true;
      })
      .sort((a, b) => a.hotel_name.localeCompare(b.hotel_name))
      .map((d) => (
        <Option key={d.hotel_id} title={`${d.hotel_code} - ${d.hotel_name}`}>
          {`${d.hotel_code} - ${d.hotel_name}`}
        </Option>
      ));

    return (
      <div className="header_2">
        <div className="header_2_a">
          <div className="header_2_aa">
            <Form
              ref={formRef}
              layout="vertical"
              onFinish={this.formOneOnFinish}
            >
              <Row gutter={[16, 16]}>
                {allHmgOptions && allHmgOptions.length > 1 ? (
                  <Col xxl={8} xl={8} lg={8} md={6} sm={24} xs={24}>
                    <Form.Item label="Hotel Management Group" name="hmg_id">
                      <Select
                        showSearch
                        // allowClear={true}
                        optionFilterProp="children"
                        notFoundContent={null}
                        placeholder="Enter Hotel Management Group"
                        onChange={this.hmgIdOnChange}
                        style={{ width: "100%" }}
                      >
                        <Option value="All">All</Option>
                        {allHmgOptions}
                      </Select>
                    </Form.Item>
                  </Col>
                ) : null}
                <Col xxl={8} xl={8} lg={8} md={6} sm={24} xs={24}>
                  <Form.Item label="Hotel" name="hotel_id">
                    <Select
                      showSearch
                      // allowClear={true}
                      optionFilterProp="children"
                      notFoundContent={null}
                      placeholder="Enter Hotel"
                      onChange={this.hotelIdOnChange}
                      disabled={!(hotelOptions.length > 1)}
                    >
                      {hotelOptions.length > 1 ? (
                        <Option value="All">All</Option>
                      ) : null}

                      {hotelOptions}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
                  <Form.Item label="Search" name="search">
                    <Input
                      prefix={
                        <SearchOutlined className="site-form-item-icon" />
                      }
                      placeholder="Search"
                      allowClear
                    />
                  </Form.Item>
                </Col>

                <Col xxl={2} xl={2} lg={2} md={2} sm={24} xs={24}>
                  <Form.Item label=" ">
                    <Button type="primary" htmlType="submit">
                      Go
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
        <div className="header_2_b">
          <div className="header_2_ba">
            <div className="header_2_baa">
              <Tooltip placement="bottomLeft" title="Add New User">
                <Button
                  onClick={() => history.push("/user-create")}
                  type="link"
                  size="large"
                  icon={
                    <FontAwesomeIcon className="anticon" icon={faUserPlus} />
                  }
                />
              </Tooltip>
            </div>
            <div className="header_2_baa">
              <Tooltip placement="bottom" title="Import">
                <Button
                  onClick={() => history.push("/bulk-user-creation")}
                  type="link"
                  size="large"
                  icon={
                    <FontAwesomeIcon
                      className="anticon"
                      icon={faCloudUploadAlt}
                    />
                  }
                />
              </Tooltip>
            </div>
            <div className="header_2_baa">
              <Tooltip placement="bottomRight" title="Export ">
                <Button
                  disabled={!(Array.isArray(dataTwo) && dataTwo.length > 0)}
                  onClick={exportOnClick}
                  type="link"
                  size="large"
                  icon={
                    <FontAwesomeIcon
                      className="anticon"
                      icon={faCloudDownloadAlt}
                    />
                  }
                />
              </Tooltip>
            </div>
            <div className="header_2_baa">
              <Tooltip placement="bottomRight" title="Normal Search ">
                <Button
                  onClick={() => history.push("/user-manager")}
                  type="link"
                  size="large"
                  icon={
                    <FontAwesomeIcon className="anticon" icon={faSearchMinus} />
                    
                  }
                />
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(FormOne);
